import React, { Component } from 'react';
import { Container } from 'reactstrap';

export class NavMenuNotLoggedIn extends Component {
  static displayName = NavMenuNotLoggedIn.name;

  constructor(props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true,
    };
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  render() {
    return (
      <header>
        <div className=" ng-white box-shadow mb-3 text-center">
          <Container fluid={false}></Container>
        </div>
      </header>
    );
  }
}
